
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[language]/youth-n-truth",
      function () {
        return require("private-next-pages/[region]/[language]/youth-n-truth/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[language]/youth-n-truth"])
      });
    }
  